import { render, staticRenderFns } from "./purchase-confirm.vue?vue&type=template&id=a64387a4&scoped=true&"
import script from "./purchase-confirm.vue?vue&type=script&lang=js&"
export * from "./purchase-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64387a4",
  null
  
)

export default component.exports